'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _immutable = require('react-redux-form/immutable');

var _bisuReactFormError = require('bisu-react-form-error');

var _bisuReactFormError2 = _interopRequireDefault(_bisuReactFormError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BisuReactInput = function BisuReactInput(_ref) {
  var model = _ref.model,
      type = _ref.type,
      label = _ref.label,
      required = _ref.required,
      props = _objectWithoutProperties(_ref, ['model', 'type', 'label', 'required']);

  return _react2.default.createElement(
    _immutable.Field,
    { model: model, className: 'bisu--react-input' },
    _react2.default.createElement(
      'label',
      { htmlFor: model },
      label,
      ' ',
      required && _react2.default.createElement(
        'span',
        { className: 'req' },
        '*'
      )
    ),
    _react2.default.createElement('input', _extends({
      type: type,
      className: 'form-control'
    }, props)),
    (0, _bisuReactFormError2.default)(model)
  );
};

process.env.NODE_ENV !== "production" ? BisuReactInput.propTypes = {
  model: _propTypes.string,
  type: _propTypes.string,
  label: _propTypes.any,
  required: _propTypes.bool
} : void 0;

BisuReactInput.defaultProps = {
  type: 'text'
};

exports.default = BisuReactInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bisu-react-input/lib/index.js
// module id = 114
// module chunks = 0